import { render, staticRenderFns } from "./ExternalLogin.vue?vue&type=template&id=86b27f4c&scoped=true"
import script from "./ExternalLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExternalLogin.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ExternalLogin.vue?vue&type=style&index=0&id=86b27f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b27f4c",
  null
  
)

export default component.exports